import {
  RECEIVE_FM_PROGRAMS,
  REQUEST_FM_PROGRAMS,
  INVALIDATE_FM_PROGRAMS,
  RECEIVE_ZD_PROGRAMS,
  REQUEST_ZD_PROGRAMS,
  INVALIDATE_ZD_PROGRAMS,
  REQUEST_PROGRAM,
  RECEIVE_PROGRAM,
  SELECT_PROGRAM_SLUG,
  INVALIDATE_PROGRAM_SLUG,
  REQUEST_EPISODES,
  RECEIVE_EPISODES,
  REQUEST_EPISODE,
  RECEIVE_EPISODE,
  CURRENT_EPISODE,
  SELECT_EPISODE_DATE,
  WANTS_PLAYLIST,
  REQUEST_PLAYLISTS,
  RECEIVE_PLAYLISTS,
  INVALIDATE_PLAYLISTS,
  CURRENT_PLAYLIST,
  ON_AIR_FM,
  ON_AIR_ZD,
	FM_LINEUP
} from './actions'

export function programsFM(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: [],
		lineup: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_FM_PROGRAMS:
      return Object.assign({}, state, {
        didInvalidate: true
      })
		case FM_LINEUP:
			return Object.assign({}, state, {
				lineup: action.shows
			})
    case REQUEST_FM_PROGRAMS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_FM_PROGRAMS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.programsFM,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function onAirZD(
  state = {
    program: null,
  },
  action )
{
  switch (action.type) {
    case ON_AIR_ZD:
      return {
        program: action.program,
        key: action.key
      }
    default:
      return state
  }
}

export function onAirFM(
  state = {
    program: null,
  },
  action )
{
  switch (action.type) {
    case ON_AIR_FM:
      return {
        program: action.program,
        key: action.key
      }
    default:
      return state
  }
}

export function programsZD(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_ZD_PROGRAMS:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_ZD_PROGRAMS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_ZD_PROGRAMS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.programsZD,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}



export function selectedEpisodeDate(state = '', action) {
  switch (action.type) {
    case SELECT_EPISODE_DATE:
      return action.date
    default:
      return state
  }
}

export function selectedProgramSlug(state = 'reactjs', action) {
  switch (action.type) {
    case SELECT_PROGRAM_SLUG:
      return action.slug
    default:
      return state
  }
}

function playlists(
  state = {
    isFetching: false,
    didInvalidate: false,
    playlists: undefined,
    wantsPlaylist: false
  },
  action
) {
  switch (action.type) {
    case REQUEST_PLAYLISTS:
      return Object.assign({}, state, {
        playlists: (state.playlists ?
          { ...state.playlists,
            [action.starttime]: {
              isFetching: true,
              didInvalidate: false,
              xhr: 'FETCHING'
            },
            currentPlaylist: action.starttime
          } :
          {
            [action.starttime]: {
              isFetching: true,
              didInvalidate: false,
              xhr: 'FETCHING'
            },
            currentPlaylist: action.starttime
          }
        )
      })
    case RECEIVE_PLAYLISTS:
      return Object.assign({}, state, {
        playlists: {
          ...state.playlists,
          [action.starttime]: {
            items: action.items,
            isFetching: false,
            didInvalidate: false,
            xhr: 'FETCHED',
            lastUpdated: action.receivedAt
          },
          currentPlaylist: action.starttime

        }
      })
    case INVALIDATE_PLAYLISTS:
      return Object.assign({}, state, {
        playlists: {
          ...state.playlists,
          [action.starttime]: {
            ...state.playlists[action.starttime],
            didInvalidate: true,
            xhr: 'INVALID'
          }

        }
      })
    case CURRENT_PLAYLIST:
      return Object.assign({}, state, {
        playlists: {
          ...state.playlists,
          currentPlaylist: action.starttime
        }
      })
    default:
      return state
  }
}

function episodes(
  state = {
    isFetching: false,
    didInvalidate: false,
    program: {},
    episodes: undefined,
    wantsPlaylist: false
  },
  action
) {
  switch (action.type) {
    case REQUEST_EPISODES:
      return Object.assign({}, state, {
        episodes: {
          isFetching: true,
          didInvalidate: false,
          xhr: 'FETCHING'
        }
      })
    case RECEIVE_EPISODES:
      let episodes = {}
      let index = []
      action.items.forEach((item) => {
        item.lastUpdated = action.receivedAt
        item.isFetching = false
        item.didInvalidate = false
        item.xhr = 'FETCHED'
        episodes[item.start] = item
        index.push(item.start)
      })
      return Object.assign({}, state, {
        episodes: {
          ...state.episodes,
          ...episodes,
          episodeIndex: index,
          isFetching: false,
          didInvalidate: false,
          xhr: 'FETCHED',
          lastUpdated: action.receivedAt
        }
      })
    case CURRENT_EPISODE:
      return Object.assign({}, state, {
        episodes: {
          ...state.episodes,
          currentEpisode: action.episode,
          currentEpisodeKey: action.key
        }
      })
    case REQUEST_EPISODE:
      let reqEp = {
        ...action.episode,
        isFetching: true,
        didInvalidate: false,
        xhr: 'FETCHING'
      }
      return Object.assign({}, state, {
        episodes: {
          ...state.episodes,
          [action.date]: reqEp
        }
      })
    case RECEIVE_EPISODE:
      let recEp = {
        ...action.episode,
        isFetching: false,
        didInvalidate: false,
        xhr: 'FETCHED'
      }
      return Object.assign({}, state, {
        episodes: {
          ...state.episodes,
          [action.episode.start]: recEp
        }
      })
    default:
      return state
  }
}

function program(
  state = {
    program: {
      isFetching: false,
      didInvalidate: false,
      program: {},
      episodes: undefined,
      playlists: undefined,
      wantsPlaylist: false
    }
  },
  action
) {
  switch (action.type) {
    case INVALIDATE_PROGRAM_SLUG:
      return Object.assign({}, state, {
        program: {
          didInvalidate: true,
          xhr: 'INVALID'
        }
      })
    case REQUEST_PROGRAM:
      return Object.assign({}, state, {
        program: {
          isFetching: true,
          didInvalidate: false,
          xhr: 'FETCHING'
        }
      })
    case RECEIVE_PROGRAM:
      return Object.assign({}, state, {
        program: {
          isFetching: false,
          didInvalidate: false,
          xhr: 'FETCHED',
          lastUpdated: action.receivedAt,
          ...action.program,

        }
      })
    default:
      return state
  }
}
 
export function programs(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_PROGRAM_SLUG:
    case RECEIVE_PROGRAM:
    case REQUEST_PROGRAM:
      return Object.assign({}, state, {
        [action.slug]: program(state[action.slug], action)
      })
    case RECEIVE_EPISODES:
    case CURRENT_EPISODE:
    case REQUEST_EPISODE:
    case RECEIVE_EPISODE:
    case REQUEST_EPISODES:
      return Object.assign({}, state, {
        [action.slug]: episodes(state[action.slug], action)
      })
    case INVALIDATE_PLAYLISTS:
    case RECEIVE_PLAYLISTS:
    case CURRENT_PLAYLIST:
    case REQUEST_PLAYLISTS:
      return Object.assign({}, state, {
        [action.slug]: playlists(state[action.slug], action)
      })
    default:
      return state
  }
}
